import * as React from 'react';

import * as styles from './styles.css';

export const NewbuildingHeaderWrapper: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className={styles['header']}>
      <div className={styles['wrapper']}>
        <div className={styles['content']}>{children}</div>
      </div>
    </div>
  );
};
